import StartNode from './StartNode';
import EndNode from './EndNode';
import AINode from './AINode';
import ConditionNode from './ConditionNode';
import APINode from './APINode';

export const nodeTypes = {
  start: StartNode,
  end: EndNode,
  ai: AINode,
  condition: ConditionNode,
  api: APINode,
};

export {
  StartNode,
  EndNode,
  AINode,
  ConditionNode,
  APINode,
};
